import React, { FC } from 'react';

const TableBodyCellNoContent: FC = () => <>—</>; // NOTE this is a long ("em") dash

export default TableBodyCellNoContent;
